module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kitchen-list/kitchen-list.component.scss
// module id = 1210
// module chunks = 0